import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import { ReactNode } from 'react';

type CardRowType = {
  title: string;
  value: ReactNode;
  variant?: 'default' | 'summary';
};

export const CheckoutCardInfoRow = ({ title, value, variant = 'default' }: CardRowType) => {
  const titleFontWeight = variant === 'summary' ? 'semibold' : 'regular';
  const valueVariant = variant === 'summary' ? 'headline2' : 'bodySmall';

  return (
    <Box width='100%' display='flex' alignItems='center' justifyContent='space-between'>
      <Typography variant='bodySmall' color={COLORS.black} fontWeight={titleFontWeight}>
        {title}
      </Typography>
      <Typography variant={valueVariant} color={COLORS.black} fontWeight='semibold'>
        {value}
      </Typography>
    </Box>
  );
};
